import { render, staticRenderFns } from "./FileReader.vue?vue&type=template&id=8c18a6e6"
import script from "./FileReader.vue?vue&type=script&lang=js"
export * from "./FileReader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports